import React, { Component } from 'react'

import * as utils from "../utils";

import { Link } from 'react-router';
import { connect } from 'react-redux';

// TODO better way to do this?  (see below)
const mobileNeedsMoreTabNames = ['what-to-bring', 'polls', 'gifts', 'donate', 'settings'];  // is that all of 'em?

const EventViewTabs = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    if (utils.isMobile()) {
      return true;
    }
    return this.state.showMore !== nextState.showMore;
  },
  getInitialState: function() {
    return {
      showMore: false
    }
  },
  render: function() {
    const { hasPoll, hasWhatToBring } = this.props.state;
    const isHost = utils.isHost();
    const isMobile = utils.isMobile();
    const showPolls = hasPoll || isHost;
    const showWhatToBring = hasWhatToBring || isHost;
    const showDonate = window.donations_enabled == true;
    const showGifts = (window.wishlist_enabled == true) ||
                      window.evite_event.options.event_option_show_gifting ||
                      Boolean(window.evite_event.registries);
    const mobileClass = isMobile ? `mobile-event-view-tabs${ window.is_premium ? " premium" : " free"}` : "";
    const needsMore = isMobile && (showPolls || showWhatToBring || showDonate || showGifts);
    const showSecondaryNav = !isMobile || (isMobile && this.state.showMore);
    // TODO better way to do this? For making the "more" tab active on mobile
    // web when one of the "more" (hidden) items is active.
    const currentTabName = window.location.pathname.split('/').pop();
    const moreTabActive = mobileNeedsMoreTabNames.indexOf(currentTabName) > -1;
    const moreTabClasses = moreTabActive ? "active" : "";
    const tabIconSuffix = isMobile ? "_mw" : "";

    return (
      <nav className={`simple-shadowbox event-view-tabs ${mobileClass}`} id="event_view_tabs">
        <ul className="primary-nav">
          <LinkItem urlPart="rsvp" displayText="RSVP" iconName={`icon-details${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          <LinkItem urlPart="activity" displayText="Activity" iconName={`icon-activity${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          <LinkItem urlPart="photos" displayText="Photos" iconName={`icon-photos${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          <LinkItem urlPart="guestlist" displayText="Guests" iconName={`icon-guests${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          { needsMore &&
            <li className="event-view-tab">
              <a href="#" onClick={this.handleMoreClick} className={moreTabClasses}>
                <i className={`icon-more${tabIconSuffix}`}></i> More
              </a>
            </li>
          }
          { isMobile && !needsMore &&
            <LinkItem urlPart="settings" displayText="Settings" iconName={`icon-edit_event${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          }
        </ul>
        { showSecondaryNav &&
          <ul className="secondary-nav">
            { showWhatToBring &&
              <LinkItem urlPart="what-to-bring" displayText="What To Bring" iconName={`icon-wtb${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            { showPolls &&
              <LinkItem urlPart="polls" displayText="Poll" iconName={`icon-polls${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            { showDonate &&
              <LinkItem urlPart="donate" displayText="Donate" iconName={`icon-donations${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            { showGifts &&
              <LinkItem urlPart="gifts" displayText="Gifts" iconName={`icon-gifts${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            <LinkItem urlPart="settings" displayText="Settings" iconName={`icon-edit_event${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          </ul>
        }
      </nav>
    )
  },
  handleMoreClick: function(e) {
    e.preventDefault();
    this.setState({
      showMore: !this.state.showMore
    })
  },
  handleLinkClick: function(e) {
    window.setTimeout(function() {
      window.dataLayer.push({
        'event': 'event_view_link_clicked',
        'destination_url': window.location.pathname,
        'tracking_src': "navigation-tab"
      });
    }, 500);
    if (utils.isMobile()) {
      this.setState({
        showMore: false
      })
    }
  }
});

function LinkItem(props) {
  const { urlPart, iconName, displayText } = props;
  return (
    <li className="event-view-tab">
      <Link
        to={utils.eventTabUrlPath(urlPart)}
        id={`tab-${urlPart}`}
        className="event-view-tab-link"
        activeClassName="active"
        onClick={props.handleLinkClick}
      >
        <i className={iconName}></i> {displayText}
      </Link>
    </li>
  )
}

function mapStateToProps(state) {
  return {
    state: {
      hasPoll: state.polls.length > 0,
      hasWhatToBring: state.whattobring.creator_id
    }
  }
};

// just some code to move the universal nav & event tabs bars up & down while
// scrolling on mobile web - see EVT-8266 for the deets
if (utils.isMobile()) {

  // Note: make sure to keep values below up-to-date w/ styling...
  const maxMoveAmount = 49;
  const tabBarOffset = 49;
  const elemsOrigTop = window.is_premium ? 0 : 59;
  const elemsMinTop = elemsOrigTop - maxMoveAmount;

  let lastScrollPos = 0;
  let elemsCurrTop = elemsOrigTop;

  function handleMobileEventViewScroll(e) {
    // the universal nav and tab bar get "nudged" up or down, if needed, by at
    // most scrollOffset at a time
    const scrollPos = $(document).scrollTop();
    if (scrollPos < 0 || scrollPos == lastScrollPos) {
      return; // invalid or no change in scroll position
    }
    const scrollOffset = lastScrollPos - scrollPos;
    const scrollingDown = scrollPos > lastScrollPos;
    const scrollingUp = scrollPos < lastScrollPos;

    lastScrollPos = scrollPos;

    const alreadyAtTop = elemsCurrTop == elemsMinTop;
    const alreadyAtOrigin = elemsCurrTop == elemsOrigTop;
    if (scrollingDown && alreadyAtTop || scrollingUp && alreadyAtOrigin) {
      return;   // no nudging needed
    }

    // adjust position by scrollOffset, then snap to top/bottom "rails" if needed
    elemsCurrTop = elemsCurrTop + scrollOffset;
    if (elemsCurrTop < elemsMinTop) {
      elemsCurrTop = elemsMinTop;
    } else if (elemsCurrTop > elemsOrigTop) {
      elemsCurrTop = elemsOrigTop;
    }
    $(".universal-nav").css({position: "fixed", top: elemsCurrTop});
    $(".mobile-event-view-tabs").css({position: "fixed", top: elemsCurrTop + tabBarOffset});
  }

  function myDocReady() {
    $(window).scroll(handleMobileEventViewScroll);
  }

  $(document).ready(myDocReady);
}

export default connect(mapStateToProps)(EventViewTabs);



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/event-view-tabs/components.es6